import { useNavigate } from "react-router-dom";
import { createContext, useEffect, useState } from "react";
import { Api } from "../../Helpers/axios/axios";
import { getCookie } from "../../Helpers/cookie/cookieUtils";

export const RenderContext = createContext<any>(null);

const RenderComponent = ({ children }: any) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    const authCookie:any = getCookie();
    const token = authCookie ? authCookie.token : null;
    if (!token) {
      navigate("/");
    }

    Api.get("/users/me").then((me)=>{
      setUser(me);
    }).catch((error)=>{
        alert(error);
        navigate("/");
    });
  }, []);

  return (
    <RenderContext.Provider value={user}>{children}</RenderContext.Provider>
  );
};

export default RenderComponent;
